import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'app-truck-summary-report-performance-filters',
	templateUrl: './truck-summary-report-performance-filters.component.html',
	styleUrls: ['./truck-summary-report-performance-filters.component.css']
})
export class TruckSummaryReportPerformanceFiltersComponent implements OnChanges, OnInit{
	constructor(private translateService: TranslateService) {}

	periods = [
		{ value: 'last_7_days', label: this.translateService.instant('durations.last_7_days') },
		{ value: 'last_14_days', label: this.translateService.instant('durations.last_14_days') },
		{ value: 'last_30_days', label: this.translateService.instant('durations.last_30_days') },
		{ value: 'last_90_days', label: this.translateService.instant('durations.last_90_days') },
		{ value: 'year_to_date', label: this.translateService.instant('durations.year_to_date') },
		{ value: 'last_year', label: this.translateService.instant('durations.last_year') },
		{ value: 'since_installation', label: this.translateService.instant('durations.all_years') },
	];

	daysFilters = [
		{ value: 'allDays', label: this.translateService.instant('g.all_days') },
		{ value: 'workingDays', label: this.translateService.instant('g.working_days') },
	];

	ngOnInit() {
		this.resetFilters();
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['resetTrigger']) {
		this.resetFilters();
		}
	}

	@Input() resetTrigger: number = 0;

	selectedPeriod = this.periods[0].value;
	selectedDays = this.daysFilters[0].value;
	@Output() filters = new EventEmitter<any>();

	onSelectionChanged(event) {
		switch (event.filter) {
			case 'period':
				this.selectedPeriod = event.value;
				break;
			case 'daysFilter':
				this.selectedDays = event.value;
				break;
			default:
				break;
		}
		this.emitFilters();
	}

	resetFilters() {
		this.selectedPeriod = this.periods[0].value;
		this.selectedDays = this.daysFilters[0].value;
		setTimeout(() => {
			this.emitFilters();
		});
	}

	emitFilters() {
		this.filters.emit({
			selectedPeriod: this.selectedPeriod,
			selectedDays: this.selectedDays
		});
	}
}
